import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import { RestApiService } from '@/services'

import { ApplicationState } from '@/state/root.models'
import { setLoadingFullAction } from '@/state/ui/global/slices/index.slices'
import { jsonToQueryString } from '@/utils'

import ActionTypes from '../constants'
import {
  TwoFactorUserPayload,
  GetBackupCodesResponse,
  UserState,
} from '../models'

const apiService: RestApiService = Container.get(RestApiService)

export const getBackupCodesThunk = createAsyncThunk(
  ActionTypes.GET_BACKUP_CODES,
  async (payload: TwoFactorUserPayload, thunkAPI) => {
    try {
      apiService.requestParams = {
        method: 'GET',
        endpoint: 'twoFactorAuthentication/getBackupCodes',
        queries: jsonToQueryString(payload),
      }

      const { auth } = thunkAPI.getState() as ApplicationState

      thunkAPI.dispatch(setLoadingFullAction(true))

      const response: GetBackupCodesResponse = await apiService.getAuthData(
        auth.token || '',
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      return response
    } catch (error) {
      return thunkAPI.rejectWithValue({
        message: error,
        status: error,
      })
    }
  },
)

const getBackupCodesExtraReducer = (
  builder: ActionReducerMapBuilder<UserState>,
) => {
  builder.addCase(getBackupCodesThunk.pending, (state) => {
    state.isLoading = true
  })
  builder.addCase(getBackupCodesThunk.fulfilled, (state, { payload }) => {
    state.isLoading = false
    state.backupCodes = payload.codes
  })
}

export default getBackupCodesExtraReducer
